import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { http } from "@bridewell/api-client";
import { Button } from "@/components/ui/button";
import { AuthLayout } from "@/features/auth/auth-layout";
import { noindexHead } from "@/features/marketing/seo";
import { t } from "@/i18n";

/**
 * Where the unsubscribe link in a reminder mail lands. Opening the link never changes anything (mail scanners open
 * links); the button does — one POST, no sign-in needed. Mail apps' own one-click button posts directly (RFC 8058).
 */
export const Route = createFileRoute("/unsubscribe")({
  validateSearch: (s: Record<string, unknown>) => ({ token: typeof s.token === "string" ? s.token : "" }),
  head: () => noindexHead(t("marketing.seo.unsubscribe")),
  component: Unsubscribe,
});

function Unsubscribe() {
  const { token } = Route.useSearch();
  const m = useMutation({ mutationFn: async () => { await http.post(`/notifications/unsubscribe?token=${encodeURIComponent(token)}`); } });
  return (
    <AuthLayout title={t("notifications.unsubTitle")}>
      {m.isSuccess ? <p className="text-[15px]">{t("notifications.unsubDone")}</p> : m.isError || !token ? (
        <p className="text-[15px] text-text-secondary">{t("notifications.unsubInvalid")}</p>
      ) : (
        <div className="flex flex-col gap-4">
          <p className="text-[15px] text-text-secondary">{t("notifications.unsubBody")}</p>
          <Button loading={m.isPending} onClick={() => m.mutate()}>{t("notifications.unsubButton")}</Button>
        </div>
      )}
    </AuthLayout>
  );
}
